import { adminlogin,querydictionarydata } from '@/api/login'
// import Layout from '@/views/layout/Layout'
import { getCode } from '@/utils'
import { setImg, getToken, setToken, removeToken, getRefreshToken, 
  setRefreshToken,removeRefreshToken, 
  getOpenid, setOpenid, removeOpenid,
  getUserid, setUserid, removeUserid,
  getNavIndex, setNavIndex
 } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    refreshtoken: getRefreshToken(),
    openid: getOpenid(),
    userid: getUserid(),
    isbind: '0',
    img: '',
    nav: true,
    dictionary: {},
    name: '',
    navIndex: getNavIndex()
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_REFRESH_TOKEN: (state, refreshtoken) => {
      state.refreshtoken = refreshtoken
    },
    SET_OPENID: (state, openid) => {
      state.openid = openid
    },
    SET_ISBIND: (state, isbind) => {
      state.isbind = isbind
    },
    SET_IMG: (state, img) => {
      state.img = img
    },
    SET_NAV: (state, nav) => {
      state.nav = nav
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_USERID: (state, userid) => {
      state.userid = userid
    },
    SET_DECTIONARY: (state, dictionary) => {
      state.dictionary = dictionary
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_NAVINDEX: (state, navIndex) => {
      state.navIndex = navIndex
    }
  },

  actions: {
    // 登录
    Login({ commit, state }) {
      var code = getCode('code')
      var data = {
        code: code,
      }
      const isDevelopment = process.env.NODE_ENV === 'development'
      if(isDevelopment){
        setOpenid('o5hiC4kFeUjAjkh_Jmevxw7NckKo')
        commit('SET_OPENID', 'o5hiC4kFeUjAjkh_Jmevxw7NckKo')
        setToken('resp_datatoken')
        setRefreshToken("resp_datarefreshtoken")
        commit('SET_TOKEN', 'resp_datatoken')
        commit('SET_REFRESH_TOKEN', 'resp_datarefreshtoken')
      }else{
        return new Promise((resolve, reject) => {
          adminlogin(data).then(response => {
            const resp_data = response.response_body
            console.log(resp_data,'resp_data')
            setToken(resp_data.token)
            setRefreshToken(resp_data.refreshtoken)
            setOpenid(resp_data.openid)
            setImg(resp_data.headimgurl)
            // setUserid(resp_data.studentid)
    
            commit('SET_OPENID', resp_data.openid)
            commit('SET_TOKEN', resp_data.token)
            commit('SET_REFRESH_TOKEN', resp_data.refreshtoken)
            // commit('SET_ISBIND', resp_data.isbind)
            // commit('SET_IMG', resp_data.headimgurl)
            // commit('SET_NAME', resp_data.nickname)
            // commit('SET_USERID', resp_data.studentid)
    
            resolve()
          }).catch(error => {
            console.log(error)
            reject(error)
          })
        })
      }
    },
    showNav({commit}, nav){
      commit('SET_NAV',nav)
    },
    changeNav({commit}, navIndex){
      commit('SET_NAVINDEX',navIndex)
      setNavIndex(navIndex)
    } 
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js